module.exports = __webpack_public_path__ + "img/footballBanner_1920.f5f31f2d.png";